import { render, staticRenderFns } from "./TrainingRecord.vue?vue&type=template&id=681f8486&scoped=true&"
import script from "./TrainingRecord.vue?vue&type=script&lang=js&"
export * from "./TrainingRecord.vue?vue&type=script&lang=js&"
import style0 from "./TrainingRecord.vue?vue&type=style&index=0&id=681f8486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f8486",
  null
  
)

export default component.exports